import FunctionalitiesService from '@/services/modules/functionalities.service';

const add = async({ commit }, _object) => {
    const response = FunctionalitiesService.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }) => {
    const response = FunctionalitiesService.get();

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const edit = async({ commit }, _module) => {
    const response = FunctionalitiesService.edit(_module.id, _module);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = FunctionalitiesService.get(_id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};


const rem = async({ commit }, _module) => {
    const response = FunctionalitiesService.rem(_module.id);

    return response;
};

export default {
    add,
    all,
    edit,
    get,
    rem
};